// src/utils/fwVersion.js
// Décodage fw_ver — miroir frontend du backend/utils/fw-version.js (contrat OTA §0).
// fw_ver = uint32 semver packé : (MAJOR<<16)|(MINOR<<8)|PATCH.

export function decode(v) {
  const n = Number(v);
  return { major: (n >> 16) & 0xff, minor: (n >> 8) & 0xff, patch: n & 0xff };
}

// "vM.m.p" ; null/undefined → null (device pré-versionnement).
export function formatVersion(v) {
  if (v === null || v === undefined || v === '') return null;
  const { major, minor, patch } = decode(v);
  return `v${major}.${minor}.${patch}`;
}

// Libellé d'affichage avec repli explicite pour les devices sans fw_ver.
export function versionLabel(v) {
  return formatVersion(v) || 'Pré-versionnement';
}
